import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";
import { faqs } from "../data/faqs";
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" cta={{
    label: "Get my complete blueprint",
    sub: "$27 USD · One-Time Payment · No Recurring Subscription"
  }} data-id="element-121" data-mp="1nvb9hur6o32z">
      <SectionHeading eyebrow="Frequently asked questions" title="Everything you need to know before purchasing" data-id="element-122" data-mp="2flxwd7s780kk" />
      <div className="mx-auto mt-10 max-w-3xl divide-y divide-navy-950/10 border-y border-navy-950/10" data-id="element-123" data-mp="21usvy3h0b496">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-124" data-mp="2ujhvvz6bt3jc" data-mpi={i}>
              <h3 data-id="element-125" data-mp="2ui6ta2oma1tt">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-[17px] font-bold leading-snug text-ink md:text-lg" data-id="element-126" data-mp="2uhndosmfvpiy">
                  {f.q}
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-brand text-white" : "bg-paper text-brand"}`} data-id="element-127" data-mp="25gvottkvo3fn">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="2aens1jqz3bz5" />
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-129" data-mp="2oddqp3tfxjpm">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-130" data-mp="2jeu4d2axq5wq">
                    <div className="space-y-2.5 pb-5 pr-10 text-[15px] leading-relaxed text-muted md:text-base" data-id="element-131" data-mp="2u2f0sldjmkg2">
                      {f.a.map(p => <p key={p} data-id="element-132" data-mp="2z06u9jtu6emd">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}